import { render } from "./navvar.vue?vue&type=template&id=c5e4d960&scoped=true"
import script from "./navvar.vue?vue&type=script&lang=js"
export * from "./navvar.vue?vue&type=script&lang=js"

import "./navvar.vue?vue&type=style&index=0&id=c5e4d960&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5e4d960"]])

export default __exports__